export default "__VITE_ASSET__18b9d2a9__"